import styled, { css } from 'styled-components';
import { lighten, rgba } from 'polished';
import { emy, fontUbuntuLight } from '../../utilities/utilities';

const Input = styled.input`
  display: block;
  -webkit-appearance: none;
  -moz-appearance: none;
  border-radius: 0;
  padding: 0.5rem;
  font-size: ${emy(17)};
  width: 100%;
  border: 1px solid #ddd;
  font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
  
  background-color: #f8f7f7;
  box-shadow: inset 0 0 10px 1px rgba(0, 0, 0, 0.075), inset 0 0 0 3px ${lighten(0.4, rgba(221, 221, 221, 1))};

  &:focus {
    border-color: rgba(0, 132, 208, 1);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), inset 0 0 0 3px ${lighten(0.4, rgba(0, 132, 208, 1))};
    outline: none;
  }

  ${props => props.error && css`
    border: 1px solid #f00;
    &:focus {
      border-color: rgba(239, 59, 59, 1);
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), inset 0 0 0 3px rgba(239, 59, 59, 0.1);
      outline: none;
    }
  `}

  ${props => props.valid && css`
    border: 1px solid rgb(86, 191, 0);
    /* border: 1px solid rgb(21, 193, 21); */
    &:focus {
      border-color: rgb(86, 191, 0);
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), inset 0 0 0 3px ${lighten(0.4, rgba(86, 191, 0, 1))};
      outline: none;
    }
  `}
`;

export default Input;


// WEBPACK FOOTER //
// ./src/components/Form/FormInput.js